import { render, staticRenderFns } from "./SliceBoardList.vue?vue&type=template&id=9d232b10&lang=pug&"
import script from "./SliceBoardList.vue?vue&type=script&lang=js&"
export * from "./SliceBoardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports